import ToolTip from "../../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return <ToolTip content={params.row.reason} expand={params.row.reason} />;
};

export const SME_LEAD_TABLE_HEAD = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  { field: "admn_no", headerName: "Admn No", width: 150 },
  { field: "name", headerName: "Name", width: 250 },
  { field: "class", headerName: "Class", width: 100 },
  {
    field: "assigned_course_name",
    headerName: "Course Name",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.assigned_course_name}
          expand={params.row.assigned_course_name}
        />
      );
    },
  },
  { field: "contactNumber", headerName: "Contact No", width: 200 },
  { field: "place", headerName: "Place", width: 150 },
  {
    field: "book_and_publication",
    headerName: "Book And Publication",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.book_and_publication}
          expand={params.row.book_and_publication}
        />
      );
    },
  },
  { field: "total_session_count", headerName: "Total Session", width: 200 },
  {
    field: "first_fee_payment_date",
    headerName: "First Fee Paid On",
    width: 200,
  },
  { field: "oga_name", headerName: "OGA Name", width: 200 },
  { field: "assigned_to", headerName: "CRO Name", width: 200 },
  {
    field: "sme_assignment_timestamp",
    headerName: "SME Assigned On",
    width: 200,
  },
  { field: "sme_assigned_to", headerName: "Assigned To", width: 200 },
  { field: "sme_assigned_by", headerName: "Assigned By", width: 200 },
  { field: "sme_call_status", headerName: "Call Status", width: 200 },
  { field: "student_status", headerName: "Student Status", width: 200 },
];
